import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    RESIDENTIAL: {
        id: 'phone.RESIDENTIAL',
        defaultMessage: 'Residential',
    },
    COMMERCIAL: {
        id: 'phone.COMMERCIAL',
        defaultMessage: 'Commercial',
    },
    MOBILE: {
        id: 'phone.MOBILE',
        defaultMessage: 'Mobile',
    },
});

export default enumMessages;
